import styled from "styled-components";
import {
  Box,
  FlexContainer,
  FlexDiv,
  FlexSection,
} from "@/components/Atoms/Box";
import theme from "@/foundation/Theme";
import Image from "@/components/Atoms/Image";

export const Wrapper = styled(FlexSection)``;

export const Container = styled(FlexContainer)``;
const OfferCardsContainer = styled(Box)`
  display: grid;
  grid-template-columns: ${({ isMobile }) => (isMobile ? "1fr" : "1fr 1fr")};
  gap: 16px;
`;

const OfferCard = styled(FlexDiv)`
  border-radius: 24px;
  padding-bottom: 16px;
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colorsV2.gray.shade_200};
  flex-direction: column;

  overflow: hidden;
`;

const ImageBox = styled(Image)`
  object-fit: contain;
`;

const CouponBox = styled(FlexDiv)`
  background-image: url("${process.env.PUBLIC_URL}/images/Subtract.jpg");
  background-size: contain;
  height: 140px;
  width: 192px;
  background-repeat: no-repeat;

  @media only screen and (max-width: 600px) {
    background-image: url("${process.env
      .PUBLIC_URL}/images/subtract-mobile.jpg");
    height: 84px;
    width: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
`;

const LogoContainer = styled(FlexDiv)`
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.06);
  border-radius: 50%;
`;

const MoreItemCard = styled(FlexDiv)`
  border-radius: 24px;
  padding: ${({ isCardVariant, isMobile }) =>
    isCardVariant
      ? isMobile
        ? "50px 24px 50px 24px"
        : "94px 24px 94px 24px"
      : "24px"};
  background-color: ${theme.colorsV2.gray.shade_50};

  flex-direction: ${({ isCardVariant, isMobile }) =>
    isCardVariant || isMobile ? "column" : "row"};
  justify-content: ${({ isCardVariant, isMobile }) =>
    isCardVariant || isMobile ? "flex-start" : "space-between"};
  align-items: center;
  gap: 16px;
`;

const MoreItemLogoRow = styled(FlexDiv)`
  align-items: center;
  gap: ${({ isMobile }) => (isMobile ? "23px" : "53.33px")};
  justify-content: center;
`;

const LogoContainer2 = styled(LogoContainer)`
  ${({ showGradient }) => {
    return (
      false &&
      `
  background: linear-gradient(
    90deg,
    #f9fafb 0%,
    #f9fafb 29.3%,
    rgba(249, 250, 251, 0) 75%
  );
  `
    );
  }}
`;

export {
  OfferCardsContainer,
  OfferCard,
  ImageBox,
  CouponBox,
  LogoContainer,
  MoreItemCard,
  MoreItemLogoRow,
  LogoContainer2,
};
